import * as React from 'react';
export const polygonSvg = React.forwardRef(function polygonSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#7B3FE4',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27 16.385v4.978a1.798 1.798 0 0 1-.88 1.535l-4.297 2.484a1.715 1.715 0 0 1-1.76 0l-4.297-2.484a1.79 1.79 0 0 1-.88-1.535v-1.397l2.2-1.282v2.429l3.85 2.242 3.85-2.242v-4.474l-3.85-2.243-9.02 5.244a1.788 1.788 0 0 1-1.76 0l-4.297-2.494A1.791 1.791 0 0 1 5 15.612v-4.978A1.799 1.799 0 0 1 5.88 9.1l4.298-2.483a1.73 1.73 0 0 1 1.76 0L16.235 9.1a1.79 1.79 0 0 1 .88 1.535v1.398L14.9 13.305V10.89l-3.85-2.242L7.2 10.89v4.469l3.85 2.242 9.02-5.243a1.787 1.787 0 0 1 1.76 0l4.297 2.494A1.792 1.792 0 0 1 27 16.385Z',
      fill: '#fff',
    }),
  );
});
polygonSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var polygon = {
  category: 'brand',
  colorable: false,
  name: 'polygon',
  svg: polygonSvg,
};
